var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import TableColumns from "./TableColumns";
import TableBody from "./TableBody";
import { classNames } from "../Util";
import TableBodyWrapper from "./TableBodyWrapper";
import TableWrapper from "./TableWrapper";
var Table = function (_a) {
    var columns = _a.columns, data = _a.data, onRowClick = _a.onRowClick, footer = _a.footer, emptyState = _a.emptyState, className = _a.className, _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.sortingDisabled, sortingDisabled = _c === void 0 ? false : _c, draggableRowsOptions = _a.draggableRowsOptions;
    var _d = useState(), draggingRowIndex = _d[0], setDraggingRowIndex = _d[1];
    return (_jsxs("div", __assign({ className: classNames("flex flex-col rounded-lg overflow-hidden shadow ring-1 ring-black ring-opacity-5", className ? className : "") }, { children: [_jsx("div", __assign({ className: "min-w-full relative overflow-x-auto" }, { children: _jsx(TableWrapper, __assign({ setDraggingRowIndex: setDraggingRowIndex, draggableRowsOptions: draggableRowsOptions }, { children: _jsxs("table", __assign({ className: "min-w-full divide-y divide-gray-300" }, { children: [!hideHeader &&
                                _jsx(TableColumns, { sortingDisabled: sortingDisabled, columns: columns }), data.length > 0 &&
                                _jsx(TableBodyWrapper, __assign({ isDraggable: draggableRowsOptions !== undefined }, { children: function (provided) { return (_jsx(TableBody, { columns: columns, data: data, onRowClick: onRowClick, draggableTableBodyOptions: provided && {
                                            droppableProvided: provided,
                                            draggingRowIndex: draggingRowIndex,
                                        } })); } }))] })) })) })), (emptyState && data.length === 0) && emptyState, footer &&
                _jsx("div", __assign({ className: "bg-white py-3.5 px-4 sm:px-6 border-t" }, { children: footer }))] })));
};
export default Table;
